module.exports = __webpack_public_path__ + "img/thumb3.a9112391.png";